import React, { useContext } from 'react';
export var PlotContext = React.createContext({});
// Exposes uPlot instance and bounding box of the entire canvas and plot area
export var usePlotContext = function () {
    return useContext(PlotContext);
};
var throwWhenNoContext = function (name) {
    throw new Error(name + " must be used within PlotContext or PlotContext is not ready yet!");
};
// Exposes API for registering uPlot plugins
export var usePlotPluginContext = function () {
    var ctx = useContext(PlotContext);
    if (Object.keys(ctx).length === 0) {
        throwWhenNoContext('usePlotPluginContext');
    }
    return {
        registerPlugin: ctx.registerPlugin,
    };
};
export var buildPlotContext = function (isPlotReady, canvasRef, data, registerPlugin, getPlotInstance) {
    return {
        isPlotReady: isPlotReady,
        canvasRef: canvasRef,
        data: data,
        registerPlugin: registerPlugin,
        getPlotInstance: getPlotInstance,
        getSeries: function () { return getPlotInstance().series; },
        getCanvas: function () {
            var plotInstance = getPlotInstance();
            var bbox = plotInstance.bbox;
            var pxRatio = window.devicePixelRatio;
            return {
                width: plotInstance.width,
                height: plotInstance.height,
                plot: {
                    width: bbox.width / pxRatio,
                    height: bbox.height / pxRatio,
                    top: bbox.top / pxRatio,
                    left: bbox.left / pxRatio,
                },
            };
        },
    };
};
//# sourceMappingURL=context.js.map